package com.trevorwiebe.timesheet.admin.carrier.presentation

import com.trevorwiebe.timesheet.core.domain.model.Carrier

enum class CarrierFilter { ACTIVE, INACTIVE, DELETED }

data class CarriersState(
    val carriers: List<Carrier> = emptyList(),
    val activeFilters: Set<CarrierFilter> = setOf(CarrierFilter.ACTIVE),
    val showAddEditDialog: Boolean = false,
    val editingCarrier: Carrier? = null,
    val isLoading: Boolean = false,
    val error: String? = null
) {
    // Keeps the repository's order (manual sort position) — no re-sorting here.
    val displayedCarriers: List<Carrier>
        get() = carriers.filter { carrier ->
            activeFilters.any { filter ->
                when (filter) {
                    CarrierFilter.ACTIVE -> carrier.active && !carrier.deleted
                    CarrierFilter.INACTIVE -> !carrier.active && !carrier.deleted
                    CarrierFilter.DELETED -> carrier.deleted
                }
            }
        }

    // Reordering is only meaningful when the full active set is visible, so the reordered
    // id list always covers everything the dispatch board will show.
    val reorderEnabled: Boolean
        get() = activeFilters == setOf(CarrierFilter.ACTIVE)
}
